/**
 * These values are from the RFC-5231 Email specification
 */
const EmailConstants = {
    emailAddressMaxLength: 250,
    subjectMaxLength: 78,
};

export default EmailConstants;
